import { getSpreadNameAsync } from "../components/navigation-bar/get-spread-names-async";
import { useAppContext } from "./useAppContext";
import { useProductCategory } from "./useProductCategory";
import { useProductCode } from "./useProductCode";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useSpreadCount } from "./useSpreadCount";

/**
 * Extracted logic for spread name
 */
export const useSpreadName = (spread: eXpress.core.Spread | undefined) => {
	const {
		localizedContent,
		context: { language },
	} = useAppContext();

	// Some page labels depend on productCode or productCategory
	// We need to trigger an update when this changes
	const productCode = useProductCode();
	const productCategory = useProductCategory();
	const spreadCount = useSpreadCount();
	const spreadIndex = spread?.index ?? -1;

	const { data: spreadName } = useQuery({
		// eslint-disable-next-line @tanstack/query/exhaustive-deps
		queryKey: [
			"use-spread-name",
			spread?.oid, // spread or defintion changed
			spreadIndex, // spread position changed changed
			spreadCount, // spread added/removed,
			productCode,
			productCategory,
		],
		queryFn: async () => {
			return getSpreadNameAsync(spread?.definition, spread, spreadIndex + 1, spreadCount, {
				getLocalizedMonthNames: () => eXpress.getLocalizedMonthNames(language),
				localizedContent,
			});
		},
		placeholderData: keepPreviousData,
		meta: { logToServer: true, errorPrefix: "Error getting spread name" },
	});

	return spreadName || "";
};
